import React, { Component } from 'react'
import _ from 'lodash'
import update from 'immutability-helper'
import qs from 'qs'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import Dls from '../../lib'
import {api} from '../../api'
import {Breadcrumb, Button, Icon, Table, Label, Modal} from 'semantic-ui-react'
import TablePagination from '../utils/tables/TablePagination'
import {
    fetchIntegrationLogs
} from '../../actions/setting'

const actionType = [
    'IMPORT_WOO_PRODUCT_BY_ID',
    'IMPORT_WOO_ORDER_BY_ID',

]

class IntegrationLogPage extends Component {
    constructor() {
        super();
        this.state = {
            routing: {
                params: {
                    on_page: 1,
                    per_page: 15,
                    order_by: {
                        created_at: 'desc'
                    }
                },
                path: ""
            },
            credentialId: "",
            partner: "",
            logView: {
                modal: false,
                data: {}
            },
            loading: false
        };
    }

    componentDidMount() {
        const { params } = this.props.match;
        this.setQueryParamsFromPath(params);
    }

    componentWillReceiveProps(props) {
        const { params } = props.match;
        this.setQueryParamsFromPath(params);
    }

    setQueryParamsFromPath = ({params, credentialId, partner}) => {
        if (this.state.routing.path !== params || this.state.credentialId !== credentialId) {
            const parsedParams = qs.parse(params);
            
            this.setState({
                routing: { params:parsedParams, path: params },
                credentialId: credentialId,
                partner: partner
            }, () => {
                this.fetchRecrods();
            });
        }
    };

    fetchRecrods = () => {
        const {jwt} = this.props;
        const {params} = this.state.routing;
        this.props.fetchIntegrationLogs(this.state.credentialId, jwt, qs.stringify(params));
    }

    routeTo = () => {
        const {credentialId, partner} = this.state;
        this.props.history.push(`/settings/integrations/${partner}/${credentialId}/${qs.stringify(this.state.routing.params)}`);
    }

    goToPage = (page) => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    on_page: { $set: page }
                })
            }
        }, () => {
            this.routeTo();
        });
    }

    retryIntegration = (i) => {
        api.integrations.retryFailedLog(this.props.jwt, this.state.credentialId, i.id).then(res => {
            Dls.info('Retry action sent. Please check back to see the status. It may take up to a minute depending on the integration.');
        }).catch(err => {
            Dls.apiErrorAlert(err);
        })
    }
    
    render() {
        const {list} = this.props;
        const {partner} = this.state;
        return (
            <div>
                <div className="row" style={{ marginBottom: "5px" }}>
                    <div className="col-md-8">
                        <Breadcrumb size="huge">
                            <Breadcrumb.Section>
                                Integrations
                            </Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section>
                                {_.upperFirst(partner)}
                            </Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section>
                                Web Service Log
                            </Breadcrumb.Section>
                        </Breadcrumb>
                    </div>
                </div>
            
                <div className="row">
                    <div className="col-md-12">
                        <Table compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Log Id</Table.HeaderCell>
                                    <Table.HeaderCell>Message</Table.HeaderCell>
                                    <Table.HeaderCell>Reference</Table.HeaderCell>
                                    <Table.HeaderCell>Date</Table.HeaderCell>
                                    <Table.HeaderCell>Retry</Table.HeaderCell>
                                    <Table.HeaderCell>View</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {_.isArray(list.data) ? list.data.map(i => {
                                    return <Table.Row key={i.id}>
                                        <Table.Cell>
                                            {i.id}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.message}
                                        </Table.Cell>
                                        <Table.Cell>{i.item_reference}</Table.Cell>
                                        <Table.Cell>
                                            {i.created_at}
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Button 
                                                size='mini' 
                                                loading={this.state.loading}
                                                disabled={this.state.loading}
                                                onClick={() => {this.retryIntegration(i)}}
                                                color='teal'>Retry</Button>
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.exception ? <Button size="mini"
                                                onClick={() => {
                                                    this.setState({
                                                        logView: {
                                                            modal: true,
                                                            data: i.exception
                                                        }
                                                    })
                                                }}
                                                color='teal'>
                                                View
                                            </Button> : null}
                                        </Table.Cell>
                                    </Table.Row>
                                }) : null}
                            </Table.Body>
                        </Table>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12" style={{marginTop: '5px'}}>
                        <TablePagination 
                            goToPage={(page) => {this.goToPage(page);}}
                            on_page={list.on_page} 
                            total_records={list.total_count} 
                            per_page={list.per_page} />
                    </div>
                </div>

                <Modal size='large' open={this.state.logView.modal} onClose={() => {
                    this.setState({
                        logView: {
                            modal: false,
                            data: {}
                        }
                    })
                }}>
                    <Modal.Header>Integration Error Message</Modal.Header>
                    <Modal.Content>
                        <p>{_.isObject(this.state.logView.data) ? this.state.logView.data.exception_message : ""}</p>
                    </Modal.Content>
                </Modal>
            </div>
        )
    }
}

IntegrationLogPage.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    fetchIntegrationLogs: PropTypes.func.isRequired,
    list: PropTypes.object.isRequired,
    jwt: PropTypes.string.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        list: state.integrations.list
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchIntegrationLogs
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationLogPage)


// WEBPACK FOOTER //
// ./src/components/settings/IntegrationLog.js